import React from 'react';
import { Image, View } from 'react-native';
import Label from '../Label';
import useCustomTheme from '../../../hooks/theme-hook';
import useTranslation from '../../../hooks/translation-hook';
import referralIcon from '../../../../assets/refer-icon.png';
export { REFERRAL_PURPLE } from '../../../styles/referralPalette';

export const referralBackgroundColor = (dark?: boolean, selected = false) =>
  selected ? (dark ? '#4B466C' : '#CFD1FF') : (dark ? '#353650' : '#E6E7FF');

export default function ReferralBadge({ iconOnly = false, color: colorOverride }: { iconOnly?: boolean; color?: string }) {
  const theme = useCustomTheme();
  const t = useTranslation();
  const color = colorOverride ?? (theme.isDark ? '#D8D0FF' : '#51408F');
  return (
    <View testID={iconOnly ? 'mission-referral-icon' : 'mission-referral-badge'}
      accessible={iconOnly} accessibilityRole={iconOnly ? 'image' : undefined}
      accessibilityLabel={iconOnly ? t('mission-referral-badge') : undefined}
      style={{ flexDirection: 'row', alignItems: 'center', alignSelf: iconOnly ? 'center' : 'flex-start',
        flexShrink: 0, paddingVertical: iconOnly ? 0 : 2 }}>
      {/* Use the visible glyph's bounds for both list icons and detail labels. */}
      <View style={{ width: 16, height: 18, overflow: 'hidden', flexShrink: 0, marginRight: iconOnly ? 0 : 5 }}>
        <Image source={referralIcon} resizeMode="contain"
          style={{ position: 'absolute', width: 36, height: 18, left: -9.5, top: 1.5, tintColor: color }} />
      </View>
      {!iconOnly && <Label style={{ color, fontSize: 11, lineHeight: 18, fontWeight: '600', includeFontPadding: false }}>
        {t('mission-referral-badge')}
      </Label>}
    </View>
  );
}
